import React from "react";
import Unlocked20 from "@carbon/icons-react/lib/unlocked/20";
import Locked20 from "@carbon/icons-react/lib/locked/20";
import { Box, IconButton } from "@material-ui/core";
import Add24 from "@carbon/icons-react/lib/add/24";
import Edit24 from "@carbon/icons-react/lib/edit/24";
import StreamStyles from "../styles/StreamStyles";
import StreamMarkerNavigation from "./StreamMarkerNavigation";

const StreamMarkerControls = ({
	disabled,
	freezeMarker,
	setFreezeMarker,
	setSelectedId,
	marker,
	selectedId,
	createMarker,
	setCreateMarker,
	sortedMarkers
}) => {
	const classes = StreamStyles();

	const handleToggleFreeze = () => {
		if (freezeMarker) {
			setFreezeMarker(false);
			setSelectedId(null);
		} else if (marker?.id) {
			setFreezeMarker(true);
		}
	};

	return (
		<Box className={classes.streamMkrControlsContainer}>
			<IconButton
				aria-label={freezeMarker ? "Unlock marker" : "Lock marker"}
				disabled={disabled}
				color={freezeMarker ? "primary" : "secondary"}
				onClick={handleToggleFreeze}
			>
				{freezeMarker ? <Locked20 /> : <Unlocked20 />}
			</IconButton>

			<StreamMarkerNavigation
				disabled={disabled}
				sortedMarkers={sortedMarkers}
				selectedId={selectedId}
				setSelectedId={setSelectedId}
				setFreezeMarker={setFreezeMarker}
			/>

			<IconButton
				disabled={disabled}
				aria-label={marker?.id && freezeMarker ? "Edit marker" : "Add marker"}
				color={createMarker ? "primary" : "secondary"}
				onClick={() => {
					setCreateMarker(!createMarker);
				}}
			>
				{marker?.id && freezeMarker ? <Edit24 /> : <Add24 />}
			</IconButton>
		</Box>
	);
};

export default StreamMarkerControls;
